import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { useNavigate, useParams } from "react-router-dom";

function PaymentFailPage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const homeBtnClick = () => {
        navigate(`/ws/${id}/homepage`);
    }
    return (
        <Container maxWidth={1200}>
            <VerticalFlex flexStart>
                <FlexChild>
                    <P weight={"bold"} size={"min(3.2vw, 30px)"}>결제에 실패했습니다</P>
                </FlexChild>
                <FlexChild>
                    <CustomButton text={"홈으로"} onClick={homeBtnClick} />
                </FlexChild>
            </VerticalFlex>

        </Container>
    );
}

export default PaymentFailPage;